import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Button, Notification } from '@shared';

export interface CommentDialogData {
  label: string;
  sublabel?: string;
  placeholder: string;
  /**
   * Optional async submit handler. When provided, the dialog stays open and
   * shows a loading state while it runs, closing only on success; existing
   * callers that omit it keep the original fire-and-close-immediately
   * behaviour.
   */
  onSubmit?: (value: string) => Observable<unknown>;
}

@Component({
  selector: 'lib-comment-dialog',
  imports: [FormsModule, Button],
  templateUrl: './comment-dialog.html',
  styleUrl: './comment-dialog.css',
})
export class CommentDialog {
  data = inject<CommentDialogData>(MAT_DIALOG_DATA);
  dialog = inject(MatDialogRef<CommentDialog>);
  notify = inject(Notification);
  comment = '';
  errorMessage: string = '';
  isSubmitting = signal(false);

  onSubmit() {
    if (this.isSubmitting()) return;

    if (!this.comment) {
      this.notify.error('Comment is required');
      this.errorMessage = 'Comment is required';
      return;
    }

    if (!this.data.onSubmit) {
      this.dialog.close(this.comment);
      return;
    }

    this.errorMessage = '';
    this.isSubmitting.set(true);
    this.dialog.disableClose = true;
    this.data.onSubmit(this.comment).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialog.disableClose = false;
        this.dialog.close(this.comment);
      },
      error: () => {
        this.isSubmitting.set(false);
        this.dialog.disableClose = false;
        this.errorMessage = 'Something went wrong. Please try again.';
      },
    });
  }

  onCancel() {
    if (this.isSubmitting()) return;
    this.dialog.close();
  }
}
